export default () => {
  document.addEventListener("DOMContentLoaded", () => {
    let styleContents = `
    :root {
      --a11y-color-widget-bg: var(--a11y-color-widget-bg-override, white);
      --a11y-color-widget-text: var(--a11y-color-widget-text-override, black);
      --a11y-color-widget-border: var(--a11y-color-widget-border-override, lightgray);
      --a11y-color-primary: var(--a11y-color-primary-override, black);
      --a11y-color-secondary: var(--a11y-color-secondary-override, white);
      --a11y-color-highlight: var(--a11y-color-highlight-override, royalblue);
      --a11y-border-radius: var(--a11y-border-radius-override, 0px);
      --a11y-cb: var(--a11y-cb-override, cubic-bezier(.21, .4, .48, 1));
      --a11y-z-index: var(--a11y-z-index-override, 100000);
      --a11y-breakpoint: var(--a11y-breakpoint-override, 1200px);
      --a11y-offset-x: var(--a11y-offset-x-override, 10px);
      --a11y-offset-y: var(--a11y-offset-y-override, 10px);
      --a11y-menu-toggle-width-mobile: var(--a11y-menu-toggle-width-mobile-override, 47px);
      --a11y-menu-toggle-height-mobile: var(--a11y-menu-toggle-height-mobile-override, 47px);

      // --a11y-focus-outline-color: var(--a11y-focus-outline-color-override, #ffffff);
      // --a11y-focus-outline-offset: var(--a11y-focus-outline-offset-override, 2px);
      // --a11y-focus-outline-style: var(--a11y-focus-outline-style-override, double);
      // --a11y-focus-outline-width: var(--a11y-focus-outline-width-override, 1px);
      // --a11y-focus-outline-shadow: var(--a11y-focus-outline-shadow-override, 0 0 0 2px #275DC5);
    }

    // *:focus-visible {
    //   outline-color: var(--a11y-focus-outline-color);
    //   outline-offset: var(--a11y-focus-outline-offset);
    //   outline-style: var(--a11y-focus-outline-style);
    //   outline-width: var(--a11y-focus-outline-width);
    //   box-shadow: var(--a11y-focus-outline-shadow);
    // }
    `;

    const style = document.createElement("style");
    style.innerHTML += styleContents;
    let head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(style);
  });
}